import Api from './ApiRequest.js';

export default {
	getAll: () => Api.get('/cent/certificates'),
    getById: (id) => Api.get(`/cent/certificate/${id}`),
    add: (data, certificate) => Api.upload('/cent/certificate', {certificate}, data),
    update: (id, data, certificate) => {
        if (!!certificate) {
            return Api.put(`/cent/certificate/${id}`, data, {certificate});
        } else {
            return Api.put(`/cent/certificate/${id}`, data);
        }
    },
    delete: (id) => Api.delete(`/cent/certificate/${id}`),
    search: (searchText) => Api.get('/cent/certificates/search', {q: searchText}),
    addField: (id, draft) => Api.post(`/cent/certificate/${id}/field`, draft),
    updateField: (id, draft) => Api.put(`/cent/certificate/${id}/field/${draft.id}`, draft),
    removeField: (id, current) => Api.delete(`/cent/certificate/${id}/field/${current.id}`),
    getFonts: () => Api.get('/cent/certificate/fontlist'),
    getPaperSizes: () => Api.get('/cent/certificate/paper-sizes')
};
